<!-- Layer Tree Content -->
<medsurf-design-content-template-slide-tree #template_slide_tree
  class="w-full">
  <!-- No Data Template -->
  <ng-template #no_data_template
    let-depth="depth">
    <div [class]="FlatModels.TreeDesignModels.TreeDragNode">
      <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContent">
        <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentHandleContainer">
          &nbsp;
        </div>
        <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentNoDataContainer(depth)">
          <span [class]="FlatModels.TreeDesignModels.TreeDragNodeNoDataText">
            {{ 'global.no_data' | translate }}
          </span>
        </div>
      </div>
    </div>
  </ng-template>

  <!-- Slide Template -->
  <ng-template #override_slide_template
    let-page="page"
    let-depth="depth">
    <div [class]="FlatModels.TreeDesignModels.TreeDragNode">
      @if ({
        editPanelDisplay: (slideAuthorFacade.editPanelDisplay$ | async) || '',
        editPanelOverlay: slideAuthorFacade.editPanelOverlay$ | async
      }; as selectionData) {
        <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContent"
          [class.selected]="!selectionData.editPanelOverlay && FlatModels.SlideAuthorModels.EditPanelSelected.includes(selectionData.editPanelDisplay)"
          (click)="onChangeEditPanelDisplay(FlatModels.SlideAuthorModels.EditPanelDisplay.enum.metadata)">
          <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentHandleContainer">
            &nbsp;
          </div>
          <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentDropDownContainer(depth)">
            <i [class]="FlatModels.PageEntityModels.PageTypeAndDepthIcon(page.type, 0)"></i>
          </div>
          <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentTitleContainer">
            <span [class]="FlatModels.TreeDesignModels.TreeDragNodeContentText"
              [title]="page.title">
              {{ page.title }}
            </span>
          </div>
        </div>
      }
    </div>
  </ng-template>

  <!-- Slide Layers Template -->
  <ng-template #override_slide_layers_template
    let-templateSlideTree="templateSlideTree"
    let-page="page"
    let-depth="depth">
    <div [class]="FlatModels.TreeDesignModels.TreeDragNode">
      <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContent">
        <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentHandleContainer">
          &nbsp;
        </div>
        <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentDropDownContainer(depth)">
          <button medsurf-design-input-button [id]="'slide_layers_toggle_' + page.id"
            [title]="(!templateSlideTree.typedSlideLayersExpanded[page.id] ? 'global.slide_layers_toggle_open' : 'global.slide_layers_toggle_close') | translate"
            [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_SMALL_TEXT"
            [iconClass]="(!templateSlideTree.typedSlideLayersExpanded[page.id] ? FlatModels.ButtonDesignModels.ButtonDefaultIcons.RIGHT : FlatModels.ButtonDesignModels.ButtonDefaultIcons.DOWN)"
            [disabled]="page.layers.length === 0"
          (click)="templateSlideTree.onSlideLayersExpand(page)"></button>
        </div>
        <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentTitleContainer">
          <span [class]="FlatModels.TreeDesignModels.TreeDragNodeContentText"
            [title]="'global.layers' | translate">
            {{ 'global.layers' | translate }}
          </span>
        </div>
        <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentOptionContainer">
          @if ([FlatModels.PageEntityModels.PageType.enum.Slide, FlatModels.PageEntityModels.PageType.enum.Training, FlatModels.PageEntityModels.PageType.enum.QuizStart].includes(page.type)) {
            <medsurf-design-input-menu
              [formField]="false"
              [name]="'slide_layers_menu_' + page.id"
              [tooltipLabel]="'global.slide_layers_menu' | translate"
              [class]="FlatModels.TreeDesignModels.TreeDragNodeHiddenElement"
              [buttonInputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_SMALL_OUTLINED"
              [buttonIconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.LAYER"
              [loadMenuItems]="getSlideLayersMenuItems"
            (click)="templateSlideTree.handleEvent()"></medsurf-design-input-menu>
          }
        </div>
      </div>
      @if (slideAuthorFacade.layers$(page.layers) | async | sortBy_shared:'asc':'position'; as layers) {
        <div [hidden]="!templateSlideTree.typedSlideLayersExpanded[page.id]"
          [class]="FlatModels.TreeDesignModels.TreeDragNodeContentContainer">
          @if (page.layers.length === 0) {
            <ng-container *ngTemplateOutlet="no_data_template;context:{
                          depth: depth + 1}"></ng-container>
          }
          @if (layers.length === 0) {
            <!-- page.layers is a string of ids -->
            @for (i of page.layers; track i) {
              <p-skeleton [height]="FlatModels.TreeDesignModels.TreeDragNodeSkeletonHeight"
                class="cursor-wait"
              ></p-skeleton>
            }
          }
          @if (layers.length > 0) {
            <div
              [dragula]="getDragulaKey('slide-tree-layers')"
              [dragulaModel]="layers"
              (dragulaModelChange)="onLayerMoved($event)">
              <ng-container *ngFor="let layer of layers; trackBy:templateSlideTree.trackByLayer; index as layerIndex">
              <!-- @for (layer of layers; track templateSlideTree.trackByLayer(layerIndex, layer); let layerIndex = $index) { -->
                <ng-container *ngTemplateOutlet="override_layer_template;context:{
                              templateSlideTree,
                              layerIndex,
                              layer,
                              depth: depth + 1}">
                </ng-container>
              </ng-container>
            </div>
          }
        </div>
      }
    </div>
  </ng-template>

  <!-- Slide Groups Template -->
  <ng-template #override_slide_groups_template
    let-templateSlideTree="templateSlideTree"
    let-page="page"
    let-depth="depth">
    <div [class]="FlatModels.TreeDesignModels.TreeDragNode">
      <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContent">
        <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentHandleContainer">
          &nbsp;
        </div>
        <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentDropDownContainer(depth)">
          <button medsurf-design-input-button [id]="'slide_groups_toggle_' + page.id"
            [title]="(!templateSlideTree.typedSlideGroupsExpanded[page.id] ? 'global.slide_groups_toggle_open' : 'global.slide_groups_toggle_close') | translate"
            [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_SMALL_TEXT"
            [iconClass]="(!templateSlideTree.typedSlideGroupsExpanded[page.id] ? FlatModels.ButtonDesignModels.ButtonDefaultIcons.RIGHT : FlatModels.ButtonDesignModels.ButtonDefaultIcons.DOWN)"
            [disabled]="page.groups.length === 0"
          (click)="templateSlideTree.onSlideGroupsExpand(page)"></button>
        </div>
        <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentTitleContainer">
          <span [class]="FlatModels.TreeDesignModels.TreeDragNodeContentText"
            [title]="'global.groups' | translate">
            {{ 'global.groups' | translate }}
          </span>
        </div>
        <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentOptionContainer">
          <medsurf-design-input-menu [formField]="false"
            [name]="'slide_groups_menu_' + page.id"
            [tooltipLabel]="'global.slide_groups_menu' | translate"
            [class]="FlatModels.TreeDesignModels.TreeDragNodeHiddenElement"
            [buttonInputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_SMALL_OUTLINED"
            [buttonIconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.GROUP"
            [loadMenuItems]="getSlideGroupsMenuItems"
          (click)="templateSlideTree.handleEvent()"></medsurf-design-input-menu>
        </div>
      </div>
      @if (slideAuthorFacade.groups$(page.groups) | async | sortBy_shared:'asc':'order'; as groups) {
        <div [hidden]="!templateSlideTree.typedSlideGroupsExpanded[page.id]"
          [class]="FlatModels.TreeDesignModels.TreeDragNodeContentContainer">
          @if (page.groups.length === 0) {
            <ng-container *ngTemplateOutlet="no_data_template;context:{
                          depth: depth + 1}"></ng-container>
          }
          @if (groups.length === 0) {
            <!-- page.groups is a string of ids -->
            @for (i of page.groups; track i) {
              <p-skeleton [height]="FlatModels.TreeDesignModels.TreeDragNodeSkeletonHeight"
                class="cursor-wait"
              ></p-skeleton>
            }
          }
          @if (groups.length > 0) {
            <div>
              <ng-container *ngFor="let group of groups; trackBy:templateSlideTree.trackByGroup">
              <!-- @for (group of groups; track templateSlideTree.trackByGroup($index, group)) { -->
                <ng-container *ngTemplateOutlet="override_group_template;context:{
                              templateSlideTree,
                              group,
                              depth: depth + 1}">
                </ng-container>
              </ng-container>
            </div>
          }
        </div>
      }
    </div>
  </ng-template>

  <!-- Slide Questions Template -->
  <ng-template #override_slide_questions_template
    let-templateSlideTree="templateSlideTree"
    let-page="page"
    let-depth="depth">
    <div [class]="FlatModels.TreeDesignModels.TreeDragNode">
      <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContent">
        <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentHandleContainer">
          &nbsp;
        </div>
        <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentDropDownContainer(depth)">
          <button medsurf-design-input-button [id]="'slide_questions_toggle_' + page.id"
            [title]="(!templateSlideTree.typedSlideQuestionsExpanded[page.id] ? 'global.slide_questions_toggle_open' : 'global.slide_questions_toggle_close') | translate"
            [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_SMALL_TEXT"
            [iconClass]="(!templateSlideTree.typedSlideQuestionsExpanded[page.id] ? FlatModels.ButtonDesignModels.ButtonDefaultIcons.RIGHT : FlatModels.ButtonDesignModels.ButtonDefaultIcons.DOWN)"
            [disabled]="page.questions.length === 0"
          (click)="templateSlideTree.onSlideQuestionsExpand(page)"></button>
        </div>
        <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentTitleContainer">
          <span [class]="FlatModels.TreeDesignModels.TreeDragNodeContentText"
            [title]="'global.questions' | translate">
            {{ 'global.questions' | translate }}
          </span>
        </div>
        <!--
        <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentChipContainer">
          <medsurf-design-content-chip>
            <i [class]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.QUESTION"></i>
            {{ page.questions.length }}
          </medsurf-design-content-chip>
        </div>
        -->
        <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentOptionContainer">
          <medsurf-design-input-menu [formField]="false"
            [name]="'slide_questions_menu' + page.id"
            [tooltipLabel]="'global.slide_questions_menu' | translate"
            [class]="FlatModels.TreeDesignModels.TreeDragNodeHiddenElement"
            [buttonInputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_SMALL_OUTLINED"
            [buttonIconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.QUESTION"
            [loadMenuItems]="getSlideQuestionsMenuItems"
          (click)="templateSlideTree.handleEvent()"></medsurf-design-input-menu>
        </div>
      </div>
      @if (slideAuthorFacade.questions$(page.questions) | async | sortBy_shared:'asc':'order'; as questions) {
        <div [hidden]="!templateSlideTree.typedSlideQuestionsExpanded[page.id]"
          [class]="FlatModels.TreeDesignModels.TreeDragNodeContentContainer">
          @if (page.questions.length === 0) {
            <ng-container *ngTemplateOutlet="no_data_template;context:{
                          depth: depth + 1}"></ng-container>
          }
          @if (questions.length === 0) {
            <!-- page.questions is a string of ids -->
            @for (i of page.questions; track i) {
              <p-skeleton [height]="FlatModels.TreeDesignModels.TreeDragNodeSkeletonHeight"
                class="cursor-wait"
              ></p-skeleton>
            }
          }
          @if (questions.length > 0) {
            <div
              [dragula]="getDragulaKey('slide-tree-questions')"
              [dragulaModel]="questions"
              (dragulaModelChange)="onQuestionMoved($event)">
              <ng-container *ngFor="let question of questions; trackBy:templateSlideTree.trackByQuestion">
              <!-- @for (question of questions; track templateSlideTree.trackByQuestion($index, question)) { -->
                <ng-container *ngTemplateOutlet="override_question_template;context:{
                              templateSlideTree,
                              page,
                              question,
                              depth: depth + 1}">
                </ng-container>
              </ng-container>
            </div>
          }
        </div>
      }
    </div>
  </ng-template>

  <!-- Layer Template -->
  <ng-template #override_layer_template
    let-templateSlideTree="templateSlideTree"
    let-layerIndex="layerIndex"
    let-layer="layer"
    let-depth="depth">
    <div [class]="FlatModels.TreeDesignModels.TreeDragNode">
      @if ({
        selected: slideAuthorFacade.isLayerSelected$(layer.id) | async,
        current: slideAuthorFacade.isLayerCurrent$(layer.id) | async,
        hasBulkEditLayer: slideAuthorFacade.hasBulkEditLayer$(layer.id) | async
      }; as selectionData) {
        <div [id]="'se-' + layer.id"
          [class]="FlatModels.TreeDesignModels.TreeDragNodeContent"
          [class.selected]="selectionData.selected"
          (click)="setLayerIndex($event, layerIndex, layer.id)">
          <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentHandleContainer">
            <button medsurf-design-input-button [id]="'layer_handle_' + layer.id"
              [title]="'global.layer_handle' | translate"
              [class]="FlatModels.TreeDesignModels.TreeDragNodeHandleElement"
              [class.tree_hidden_element]="!selectionData.selected"
              [class.opacity-0]="selectionData.hasBulkEditLayer"
              [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.HANDLE_TEXT"
            [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.MOVE"></button>
          </div>
          <!--
          <div class="flex w-3rem">
            <medsurf-design-input-checkbox [formField]="false"
              *ngIf="{ hasBulkEditLayer: nodeSharedFacade.hasBulkEditLayer$(layer.id) | async } as pageData"
              [class]="'table-header-switch'"
              [model]="pageData.hasBulkEditLayer"
              [name]="'layer_select_all_' + layer.id"
            (valueChange)="onToggleBulkLayer($event, layer.id)"></medsurf-design-input-checkbox>
          </div>
          -->
          <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentDropDownContainer(depth)">
            <button medsurf-design-input-button [id]="'layer_toggle_' + layer.id"
              [title]="(!templateSlideTree.typedLayerExpanded[layer.id] ? 'global.layer_toggle_open' : 'global.layer_toggle_close') | translate"
              [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_SMALL_TEXT"
              [iconClass]="(!templateSlideTree.typedLayerExpanded[layer.id] ? FlatModels.ButtonDesignModels.ButtonDefaultIcons.RIGHT : FlatModels.ButtonDesignModels.ButtonDefaultIcons.DOWN)"
              [disabled]="layer.images.length === 0"
            (click)="templateSlideTree.onLayerExpand(layer)"></button>
          </div>
          <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentAttributesContainer">
            <i [class]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.LAYER"></i>
          </div>
          <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentTitleContainer">
            <span [class]="FlatModels.TreeDesignModels.TreeDragNodeContentText"
              [title]="layer.window || 'global.window_default' | translate">
              {{ layer.window || 'global.window_default' | translate }}
            </span>
          </div>
          <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentFixedTagContainer">
            @if (layer.images.length > 0) {
              <p-tag
                [icon]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.IMAGE"
              [value]="layer.images.length.toString()"/>
            }
          </div>
          <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentFixedLayerEmptyContainer">&nbsp;</div>
          <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentOptionContainer">
            @if (!selectionData.hasBulkEditLayer) {
              <medsurf-design-input-menu
                [formField]="false"
                [name]="'layer_menu_' + layer.id"
                [tooltipLabel]="'global.layer_menu' | translate"
                [class.tree_hidden_element]="!selectionData.selected"
                [buttonInputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_SMALL_OUTLINED"
                [iconOpen]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.OPTIONS"
                [iconClose]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.OPTIONS"
                [loadContext]="{type: 'layer', layer}"
                [loadMenuItems]="getLayerMenuItems"
              (click)="templateSlideTree.handleEvent()"></medsurf-design-input-menu>
            }
            @if (!selectionData.hasBulkEditLayer) {
              <medsurf-design-input-menu
                [formField]="false"
                [name]="'layer_images_menu_' + layer.id"
                [tooltipLabel]="'global.layer_images_menu' | translate"
                [class.tree_hidden_element]="!selectionData.selected"
                [buttonInputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_SMALL_OUTLINED"
                [buttonIconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.IMAGE"
                [loadContext]="{type: 'layerImages', layer}"
                [loadMenuItems]="getLayerImagesMenuItems"
              (click)="templateSlideTree.handleEvent()"></medsurf-design-input-menu>
            }
          </div>
        </div>
        @if (slideAuthorFacade.images$(layer.images) | async | sortBy_shared:'asc':'sequenceNumber'; as images) {
          <div [hidden]="!templateSlideTree.typedLayerExpanded[layer.id]"
            [class]="FlatModels.TreeDesignModels.TreeDragNodeContentContainer">
            @if (layer.images.length === 0) {
              <ng-container *ngTemplateOutlet="no_data_template;context:{
                            depth: depth + 1}"></ng-container>
            }
            @if (images.length === 0) {
              <!-- layer.images is a string of ids -->
              @for (i of layer.images; track i) {
                <p-skeleton [height]="FlatModels.TreeDesignModels.TreeDragNodeSkeletonHeight"
                  class="cursor-wait"
                ></p-skeleton>
              }
            }
            @if (images.length > 0) {
              <div
                [dragula]="getDragulaKey('slide-tree-images')"
                [dragulaModel]="images"
                (dragulaModelChange)="onImageMoved(layer, $event)">
                <ng-container *ngFor="let image of images; trackBy:templateSlideTree.trackByImage; index as imageIndex">
                <!-- @for (image of images; track templateSlideTree.trackByImage(imageIndex, image); let imageIndex = $index) { -->
                  <ng-container *ngTemplateOutlet="override_image_template;context:{
                                templateSlideTree,
                                layerIndex,
                                imageIndex,
                                layer,
                                image,
                                depth: depth + 1}">
                  </ng-container>
                </ng-container>
              </div>
            }
          </div>
        }
      }
    </div>
  </ng-template>

  <!-- Image Template -->
  <ng-template #override_image_template
    let-templateSlideTree="templateSlideTree"
    let-layerIndex="layerIndex"
    let-imageIndex="imageIndex"
    let-layer="layer"
    let-image="image"
    let-depth="depth">
    <div [class]="FlatModels.TreeDesignModels.TreeDragNode">
      @if ({
        selected: slideAuthorFacade.isImageSelected$(image.id) | async,
        current: slideAuthorFacade.isImageCurrent$(image.id) | async,
        hasBulkEditImage: slideAuthorFacade.hasBulkEditImage$(image.id) | async
      }; as selectionData) {
        @if ({
          media: slideAuthorFacade.media$(image.media) | async
        }; as mediaData) {
          <div
            [id]="'se-' + image.id"
            [class]="FlatModels.TreeDesignModels.TreeDragNodeContent"
            [class.current]="selectionData.current"
            [class.selected]="selectionData.selected"
            (click)="setImageIndex($event, layerIndex, imageIndex, image.id)"
            (dblclick)="!($event.ctrlKey || $event.metaKey) && goHome()">
            <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentHandleContainer">
              <button medsurf-design-input-button [id]="'image_handle_' + image.id"
                [title]="'global.image_handle' | translate"
                [class]="FlatModels.TreeDesignModels.TreeDragNodeHandleElement"
                [class.tree_hidden_element]="!selectionData.selected"
                [class.opacity-0]="selectionData.hasBulkEditImage"
                [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.HANDLE_TEXT"
              [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.MOVE"></button>
            </div>
            <!--
            <div class="flex w-3rem">
              <medsurf-design-input-checkbox [formField]="false"
                *ngIf="{ hasBulkEditImage: nodeSharedFacade.hasBulkEditImage$(image.id) | async } as pageData"
                [class]="'table-header-switch'"
                [model]="pageData.hasBulkEditImage"
                [name]="'image_select_all_' + image.id"
              (valueChange)="onToggleBulkImage($event, image.id)"></medsurf-design-input-checkbox>
            </div>
            -->
            <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentDropDownContainer(depth)">
              <button medsurf-design-input-button [id]="'image_toggle_' + image.id"
                [title]="(!templateSlideTree.typedImageExpanded[image.id] ? 'global.image_toggle_open' : 'global.image_toggle_close') | translate"
                [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_SMALL_TEXT"
                [iconClass]="(!templateSlideTree.typedImageExpanded[image.id] ? FlatModels.ButtonDesignModels.ButtonDefaultIcons.RIGHT : FlatModels.ButtonDesignModels.ButtonDefaultIcons.DOWN)"
              (click)="templateSlideTree.onImageExpand(image)"></button>
            </div>
            <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentImageContainer">
              <img [style]="FlatModels.TreeDesignModels.TreeDragNodeImageHeightStyle"
                [src]="mediaControlService.getUrl(mediaData.media, 'thumbnail') || '/assets/images/no-image.png'"
                [alt]="mediaData.media?.name || 'global.error_loading_image' | translate" />
            </div>
            <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentTitleContainer">
              <span [class]="FlatModels.TreeDesignModels.TreeDragNodeContentText"
                [title]="'# '+ image.sequenceNumber + (mediaData.media?.dimensions?.depth ? ' (' + mediaData.media?.dimensions?.depth + ')' : '')">
                #{{ image.sequenceNumber }} {{ (mediaData.media?.dimensions?.depth ? '(' + mediaData.media?.dimensions?.depth + ')' : '') }}
              </span>
            </div>
            <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentFixedTagContainer">&nbsp;</div>
            <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentFixedTagContainer">
              @if (image.annotations.length > 0) {
                <p-tag
                  [icon]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.ANNOTATIONS"
                  [value]="image.annotations.length.toString()"/>
              }
            </div>
            <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentFixedTagContainer">
              @if (image.pois.length > 0) {
                <p-tag
                  [icon]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.SIGN_POST"
                  [value]="image.pois.length.toString()"/>
              }
            </div>
            <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentFixedTagContainer">
              @if (image.default) {
                <p-tag
                  [icon]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.STAR"/>
              }
            </div>
            <!--
            <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentChipContainer">
              <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentChipContainer2">
                <medsurf-design-content-chip [class]="'mr-2'">
                  <i [class]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.ANNOTATIONS"></i>
                  {{ image.annotations.length }}
                </medsurf-design-content-chip>
                <medsurf-design-content-chip>
                  <i [class]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.LOCATE"></i>
                  {{ image.pois.length }}
                </medsurf-design-content-chip>
              </div>
            </div>
            -->
            <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentOptionContainer">
              @if (!selectionData.hasBulkEditImage) {
                <medsurf-design-input-menu
                  [formField]="false"
                  [name]="'image_menu_' + image.id"
                  [tooltipLabel]="'global.image_menu' | translate"
                  [class.tree_hidden_element]="!selectionData.selected"
                  [buttonInputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_SMALL_OUTLINED"
                  [iconOpen]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.OPTIONS"
                  [iconClose]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.OPTIONS"
                  [loadContext]="{type: 'image', layer, image}"
                  [loadMenuItems]="getImageMenuItems"
                (click)="templateSlideTree.handleEvent()"></medsurf-design-input-menu>
              }
            </div>
          </div>
        }
        <div [hidden]="!templateSlideTree.typedImageExpanded[image.id]"
          [class]="FlatModels.TreeDesignModels.TreeDragNodeContentContainer">
          <ng-container *ngTemplateOutlet="override_image_annotations_template,context:{
                        templateSlideTree,
                        layerIndex,
                        imageIndex,
                        image,
                        depth: depth + 1}">
          </ng-container>
          <ng-container *ngTemplateOutlet="override_image_pois_template,context:{
                        templateSlideTree,
                        layerIndex,
                        imageIndex,
                        image: image,
                        depth: depth + 1}">
          </ng-container>
        </div>
      }
    </div>
  </ng-template>

  <!-- Image Annotations Template -->
  <ng-template #override_image_annotations_template
    let-templateSlideTree="templateSlideTree"
    let-layerIndex="layerIndex"
    let-imageIndex="imageIndex"
    let-image="image"
    let-depth="depth">
    <div [class]="FlatModels.TreeDesignModels.TreeDragNode">
      <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContent" [id]="'image_annotations_' + image.id">
        <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentHandleContainer">
          &nbsp;
        </div>
        <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentDropDownContainer(depth)">
          <button medsurf-design-input-button [id]="'image_annotations_toggle_' + image.id"
            [title]="(!templateSlideTree.typedImageAnnotationExpanded[image.id] ? 'global.image_annotations_toggle_open' : 'global.image_annotations_toggle_open') | translate"
            [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_SMALL_TEXT"
            [iconClass]="(!templateSlideTree.typedImageAnnotationExpanded[image.id] ? FlatModels.ButtonDesignModels.ButtonDefaultIcons.RIGHT : FlatModels.ButtonDesignModels.ButtonDefaultIcons.DOWN)"
            [disabled]="image.annotations.length === 0"
          (click)="templateSlideTree.onImageAnnotationsExpand(image)"></button>
        </div>
        <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentTitleContainer">
          <span [class]="FlatModels.TreeDesignModels.TreeDragNodeContentText"
            [title]="'global.annotations' | translate">
            {{ 'global.annotations' | translate }}
          </span>
        </div>
        <!--
        <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentChipContainer">
          <medsurf-design-content-chip>
            <i [class]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.ANNOTATIONS"></i>
            {{ image.annotations.length }}
          </medsurf-design-content-chip>
        </div>
        -->
        <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentOptionContainer">
          <medsurf-design-input-menu [formField]="false"
            [name]="'image_annotations_menu_' + image.id"
            [tooltipLabel]="'global.image_annotations_menu' | translate"
            [class]="FlatModels.TreeDesignModels.TreeDragNodeHiddenElement"
            [buttonInputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_SMALL_OUTLINED"
            [buttonIconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.ANNOTATIONS"
            [loadContext]="{type: 'imageAnnotations', image}"
            [loadMenuItems]="getImageAnnotationsMenuItems"
          (click)="templateSlideTree.handleEvent()"></medsurf-design-input-menu>
        </div>
      </div>
      @if (slideAuthorFacade.annotations$(image.annotations) | async | sortBy_shared:'asc':'sequenceNumber'; as annotations) {
        <div [hidden]="!templateSlideTree.typedImageAnnotationExpanded[image.id]"
          [class]="FlatModels.TreeDesignModels.TreeDragNodeContentContainer">
          @if (image.annotations.length === 0) {
            <ng-container *ngTemplateOutlet="no_data_template;context:{
                          depth: depth + 1}"></ng-container>
          }
          @if (annotations.length === 0) {
            <!-- image.annotations is a string of ids -->
            @for (i of image.annotations; track i) {
              <p-skeleton [height]="FlatModels.TreeDesignModels.TreeDragNodeSkeletonHeight"
                class="cursor-wait"
              ></p-skeleton>
            }
          }
          @if (annotations.length > 0) {
            <div>
              <ng-container *ngFor="let annotation of annotations; trackBy:templateSlideTree.trackByAnnotation">
              <!-- @for (annotation of annotations; track templateSlideTree.trackByAnnotation($index, annotation)) { -->
                <ng-container *ngTemplateOutlet="override_annotation_template;context:{
                              templateSlideTree,
                              layerIndex,
                              imageIndex,
                              image,
                              annotation,
                              depth: depth + 1}">
                </ng-container>
              </ng-container>
            </div>
          }
        </div>
      }
    </div>
  </ng-template>

  <!-- Image Pois Template -->
  <ng-template #override_image_pois_template
    let-templateSlideTree="templateSlideTree"
    let-layerIndex="layerIndex"
    let-imageIndex="imageIndex"
    let-image="image"
    let-depth="depth">
    <div [class]="FlatModels.TreeDesignModels.TreeDragNode">
      <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContent" [id]="'image_pois_' + image.id">
        <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentHandleContainer">
          &nbsp;
        </div>
        <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentDropDownContainer(depth)">
          <button medsurf-design-input-button [id]="'image_pois_toggle_' + image.id"
            [title]="(!templateSlideTree.typedImagePoiExpanded[image.id] ? 'global.image_pois_toggle_open' : 'global.image_pois_toggle_open') | translate"
            [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_SMALL_TEXT"
            [iconClass]="(!templateSlideTree.typedImagePoiExpanded[image.id] ? FlatModels.ButtonDesignModels.ButtonDefaultIcons.RIGHT : FlatModels.ButtonDesignModels.ButtonDefaultIcons.DOWN)"
            [disabled]="image.pois.length === 0"
          (click)="templateSlideTree.onImagePoisExpand(image)"></button>
        </div>
        <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentTitleContainer">
          <span [class]="FlatModels.TreeDesignModels.TreeDragNodeContentText"
            [title]="'global.pois' | translate">
            {{ 'global.pois' | translate }}
          </span>
        </div>
        <!--
        <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentChipContainer">
          <medsurf-design-content-chip>
            <i [class]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.LOCATE"></i>
            {{ image.pois.length }}
          </medsurf-design-content-chip>
        </div>
        -->
        <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentOptionContainer">
          <medsurf-design-input-menu [formField]="false"
            [name]="'image_pois_menu_' + image.id"
            [tooltipLabel]="'global.image_pois_menu' | translate"
            [class]="FlatModels.TreeDesignModels.TreeDragNodeHiddenElement"
            [buttonInputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_SMALL_OUTLINED"
            [buttonIconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.SIGN_POST"
            [loadContext]="{type: 'imagePois', image}"
            [loadMenuItems]="getImagePoisMenuItems"
          (click)="templateSlideTree.handleEvent()"></medsurf-design-input-menu>
        </div>
      </div>
      @if (slideAuthorFacade.pois$(image.pois) | async | sortBy_shared:'asc':'order'; as pois) {
        <div [hidden]="!templateSlideTree.typedImagePoiExpanded[image.id]"
          [class]="FlatModels.TreeDesignModels.TreeDragNodeContentContainer">
          @if (image.pois.length === 0) {
            <ng-container *ngTemplateOutlet="no_data_template;context:{
                          depth: depth + 1}"></ng-container>
          }
          @if (pois.length === 0) {
            <!-- image.pois is a string of ids -->
            @for (i of image.pois; track i) {
              <p-skeleton [height]="FlatModels.TreeDesignModels.TreeDragNodeSkeletonHeight"
                class="cursor-wait"
              ></p-skeleton>
            }
          }
          @if (pois.length > 0) {
            <div
              [dragula]="getDragulaKey('slide-tree-pois')"
              [dragulaModel]="pois"
              (dragulaModelChange)="onImagePoiMoved(image, $event)">
              <ng-container *ngFor="let poi of pois; trackBy:templateSlideTree.trackByPoi">
              <!-- @for (poi of pois; track templateSlideTree.trackByPoi($index, poi)) { -->
                <ng-container *ngTemplateOutlet="override_image_poi_template;context:{
                              templateSlideTree,
                              layerIndex,
                              imageIndex,
                              image,
                              poi,
                              depth: depth + 1}">
                </ng-container>
              </ng-container>
            </div>
          }
        </div>
      }
    </div>
  </ng-template>

  <!-- Annotation Template -->
  <ng-template #override_annotation_template
    let-templateSlideTree="templateSlideTree"
    let-layerIndex="layerIndex"
    let-imageIndex="imageIndex"
    let-page="page"
    let-image="image"
    let-group="group"
    let-poi="poi"
    let-annotation="annotation"
    let-depth="depth">
    <div [class]="FlatModels.TreeDesignModels.TreeDragNode">
      @if ({
        selected: slideAuthorFacade.isAnnotationSelected$(annotation.id) | async,
        hasBulkEditAnnotation: slideAuthorFacade.hasBulkEditAnnotation$(annotation.id) | async
      }; as selectionData) {
        @if ({
          images: (slideAuthorFacade.imagesByAnnotation$(annotation.id) | async) || []
        }; as imageData) {
          <div
            [id]="'se-' + annotation.id"
            [class]="FlatModels.TreeDesignModels.TreeDragNodeContent"
            [class.selected]="selectionData.selected"
            (click)="setAnnotationId($event, annotation.id)"
            (dblclick)="!($event.ctrlKey || $event.metaKey) && goToAnnotation(annotation)">
            <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentHandleContainer">
              @if (poi) {
                <button medsurf-design-input-button
                  [id]="'annotation_handle_' + annotation.id"
                  [title]="'global.annotation_handle' | translate"
                  [class]="FlatModels.TreeDesignModels.TreeDragNodeHandleElement"
                  [class.tree_hidden_element]="!selectionData.selected"
                  [class.opacity-0]="selectionData.hasBulkEditAnnotation"
                  [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.HANDLE_TEXT"
                [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.MOVE"></button>
              }
            </div>
            <!--
            <div class="flex w-3rem">
              <medsurf-design-input-checkbox [formField]="false"
                *ngIf="{ hasBulkEditAnnotation: nodeSharedFacade.hasBulkEditAnnotation$(annotation.id) | async } as pageData"
                [class]="'table-header-switch'"
                [model]="pageData.hasBulkEditAnnotation"
                [name]="'annotation_select_all_' + annotation.id"
              (valueChange)="onToggleBulkAnnotation($event, annotation.id)"></medsurf-design-input-checkbox>
            </div>
            -->
            <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentDropDownContainer(depth)">
              @if (annotation.type !== FlatModels.AnnotationEntityModels.AnnotationType.enum.FreeForm) {
                @if (annotation.type === FlatModels.AnnotationEntityModels.AnnotationType.enum.Marker && annotation.targets?.length === 0) {
                  <i [class]="FlatModels.AnnotationEntityModels.AnnotationTypeIcon.Text"></i>
                } @else {
                  <i [class]="FlatModels.AnnotationEntityModels.AnnotationTypeIcon[annotation.type]"></i>
                }                
              } @else {
                <i
                [class]="FlatModels.AnnotationEntityModels.ShapeIcon[annotation.shape]"></i>
              }
            </div>
            <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentTitleContainer">
              @if (slideAuthorFacade.annotationLabelInfo$(annotation.id, translate) | async; as annotationLabel) {
                <span
                  [class]="FlatModels.TreeDesignModels.TreeDragNodeContentText"
                  [title]="annotationLabel">
                  {{ annotationLabel }}
                </span>
              }
            </div>
            <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentFixedTagContainer">
              @if (imageData.images.length > 0) {
                <p-tag
                  [icon]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.IMAGE"
                  [value]="imageData.images.length.toString()"/>
              }
            </div>
            <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentFixedTagContainer">&nbsp;</div>
            @if ({
              pois: (slideAuthorFacade.poisByAnnotation$(annotation.id) | async) || []
            }; as poiData) {
              <div
                [class]="FlatModels.TreeDesignModels.TreeDragNodeContentFixedTagContainer">
                @if (poiData.pois.length > 0) {
                  <p-tag
                    [icon]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.SIGN_POST"
                    [value]="poiData.pois.length.toString()"/>
                }
              </div>
            }
            @if ({
              groups: (slideAuthorFacade.groupsByAnnotation$(annotation.id) | async) || []
            }; as groupsData) {
              <div
                [class]="FlatModels.TreeDesignModels.TreeDragNodeContentFixedTagContainer">
                @if (groupsData.groups.length > 0) {
                  <p-tag
                    [icon]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.GROUP"
                    [value]="groupsData.groups.length.toString()"/>
                }
              </div>
            }
            <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentOptionContainer">
              @if (!selectionData.hasBulkEditAnnotation) {
                <medsurf-design-input-menu
                  [formField]="false"
                  [name]="'annotation_menu_' + annotation.id"
                  [tooltipLabel]="'global.annotation_menu' | translate"
                  [class.tree_hidden_element]="!selectionData.selected"
                  [buttonInputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_SMALL_OUTLINED"
                  [iconOpen]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.OPTIONS"
                  [iconClose]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.OPTIONS"
                  [loadContext]="{type: 'annotation', image, images: imageData.images, annotation, group, poi}"
                  [loadMenuItems]="getAnnotationMenuItems"
                (click)="templateSlideTree.handleEvent()"></medsurf-design-input-menu>
              }
            </div>
          </div>
        }
      }
    </div>
  </ng-template>

  <!-- Group Template -->
  <ng-template #override_group_template
    let-templateSlideTree="templateSlideTree"
    let-group="group"
    let-depth="depth">
    <div [class]="FlatModels.TreeDesignModels.TreeDragNode">
      @if ({
        selected: slideAuthorFacade.isGroupSelected$(group.id) | async,
        hasBulkEditGroup: slideAuthorFacade.hasBulkEditGroup$(group.id) | async
      }; as selectionData) {
        <div [id]="'se-' + group.id"
          [class]="FlatModels.TreeDesignModels.TreeDragNodeContent"
          [class.selected]="selectionData.selected"
          (click)="setGroupId($event, group.id)">
          <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentHandleContainer">
            &nbsp;
          </div>
          <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentDropDownContainer(depth)">
            <button medsurf-design-input-button [id]="'group_toggle_' + group.id"
              [title]="(!templateSlideTree.typedGroupExpanded[group.id] ? 'global.group_toggle_open' : 'global.group_toggle_close') | translate"
              [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_SMALL_TEXT"
              [iconClass]="(!templateSlideTree.typedGroupExpanded[group.id] ? FlatModels.ButtonDesignModels.ButtonDefaultIcons.RIGHT : FlatModels.ButtonDesignModels.ButtonDefaultIcons.DOWN)"
              [disabled]="group.annotations.length === 0"
            (click)="templateSlideTree.onGroupExpand(group)"></button>
          </div>
          <!--
          <div class="flex w-3rem">
            <medsurf-design-input-checkbox [formField]="false"
              *ngIf="{ hasBulkEditGroup: nodeSharedFacade.hasBulkEditGroup$(group.id) | async } as pageData"
              [class]="'table-header-switch'"
              [model]="pageData.hasBulkEditGroup"
              [name]="'group_select_all_' + group.id"
            (valueChange)="onToggleBulkGroup($event, group.id)"></medsurf-design-input-checkbox>
          </div>
          -->
          <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentAttributesContainer">
            <i [class]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.GROUP"
            [style.color]="group.color"></i>
          </div>
          <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentTitleContainer">
            <span [class]="FlatModels.TreeDesignModels.TreeDragNodeContentText"
              [title]="group.name">
              {{ group.name }}
            </span>
          </div>
          <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentFixedTagContainer">&nbsp;</div>
          <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentFixedTagContainer">
            @if (group.annotations.length > 0) {
              <p-tag
                [icon]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.ANNOTATIONS"
                [value]="group.annotations.length.toString()"/>
            }
          </div>
          <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentFixedTagContainer">&nbsp;</div>
          <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentFixedTagContainer">&nbsp;</div>
          <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentOptionContainer">
            @if (!selectionData.hasBulkEditGroup) {
              <medsurf-design-input-menu
                [formField]="false"
                [name]="'group_menu_' + group.id"
                [tooltipLabel]="'global.group_menu' | translate"
                [class.tree_hidden_element]="!selectionData.selected"
                [buttonInputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_SMALL_OUTLINED"
                [iconOpen]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.OPTIONS"
                [iconClose]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.OPTIONS"
                [loadContext]="{type: 'group', group}"
                [loadMenuItems]="getGroupMenuItems"
              (click)="templateSlideTree.handleEvent()"></medsurf-design-input-menu>
            }
          </div>
        </div>
        @if (slideAuthorFacade.annotations$(group.annotations) | async | sortBy_shared:'asc':'sequenceNumber'; as annotations) {
          <div [hidden]="!templateSlideTree.typedGroupExpanded[group.id]"
            [class]="FlatModels.TreeDesignModels.TreeDragNodeContentContainer">
            @if (group.annotations.length === 0) {
              <ng-container *ngTemplateOutlet="no_data_template;context:{
                            depth: depth + 1}"></ng-container>
            }
            @if (annotations.length === 0) {
              <!-- group.annotations is a string of ids -->
              @for (i of group.annotations; track i) {
                <p-skeleton [height]="FlatModels.TreeDesignModels.TreeDragNodeSkeletonHeight"
                  class="cursor-wait"
                ></p-skeleton>
              }
            }
            @if (annotations.length > 0) {
              <div>
                <ng-container *ngFor="let annotation of annotations; trackBy:templateSlideTree.trackByAnnotation">
                <!-- @for (annotation of annotations; track templateSlideTree.trackByAnnotation($index, annotation)) { -->
                  <ng-container *ngTemplateOutlet="override_annotation_template;context:{
                                templateSlideTree,
                                group: group,
                                annotation: annotation,
                                depth: depth + 1}">
                  </ng-container>
                </ng-container>
              </div>
            }
          </div>
        }
      }
    </div>
  </ng-template>

  <!-- Image Poi Template -->
  <ng-template #override_image_poi_template
    let-templateSlideTree="templateSlideTree"
    let-layerIndex="layerIndex"
    let-imageIndex="imageIndex"
    let-page="page"
    let-image="image"
    let-poi="poi"
    let-depth="depth">
    <div [class]="FlatModels.TreeDesignModels.TreeDragNode">
      @if ({
        selected: slideAuthorFacade.isPoiSelected$(poi.id) | async,
        hasBulkEditPoi: slideAuthorFacade.hasBulkEditPoi$(poi.id) | async
      }; as selectionData) {
        @if ({
          images: (slideAuthorFacade.imagesByPoi$(poi.id) | async) || []
        }; as imageData) {
          <div
            [id]="'se-' + poi.id"
            [class]="FlatModels.TreeDesignModels.TreeDragNodeContent"
            [class.selected]="selectionData.selected"
            (click)="setPoiId($event, poi.id)"
            (dblclick)="!($event.ctrlKey || $event.metaKey) && goToPoi(poi)">
            <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentHandleContainer">
              <button medsurf-design-input-button [id]="'image_poi_handle_' + poi.id"
                [title]="'global.image_poi_handle' | translate"
                [class]="FlatModels.TreeDesignModels.TreeDragNodeHandleElement"
                [class.tree_hidden_element]="!selectionData.selected"
                [class.opacity-0]="selectionData.hasBulkEditPoi"
                [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.HANDLE_TEXT"
              [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.MOVE"></button>
            </div>
            <!--
            <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentDropDownContainer(depth)">
              <button medsurf-design-input-button [id]="'poi_menu_toggle_' + poi.id"
                [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_SMALL_TEXT"
                [iconClass]="(!templateSlideTree.typedPoiExpanded[poi.id] ? FlatModels.ButtonDesignModels.ButtonDefaultIcons.RIGHT : FlatModels.ButtonDesignModels.ButtonDefaultIcons.DOWN)"
              (valueChange)="templateSlideTree.onPoiExpand(poi)"></button>
            </div>
            -->
            <!--
            <div class="flex w-3rem">
              <medsurf-design-input-checkbox [formField]="false"
                *ngIf="{ hasBulkEditPoi: nodeSharedFacade.hasBulkEditPoi$(poi.id) | async } as pageData"
                [class]="'table-header-switch'"
                [model]="pageData.hasBulkEditPoi"
                [name]="'poi_select_all_' + poi.id"
              (valueChange)="onToggleBulkPoi($event, poi.id)"></medsurf-design-input-checkbox>
            </div>
            -->
            <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentDropDownContainer(depth)">
              <i [class]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.SIGN_POST"></i>
            </div>
            <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentTitleContainer">
              <span [class]="FlatModels.TreeDesignModels.TreeDragNodeContentText"
                [title]="poi.name">
                {{ poi.name }}
              </span>
            </div>
            @if ({
              images: (slideAuthorFacade.imagesByPoi$(poi.id) | async) || []
            }; as imageData) {
              <div
                [class]="FlatModels.TreeDesignModels.TreeDragNodeContentFixedTagContainer">
                @if (imageData.images.length > 0) {
                  <p-tag
                    [icon]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.IMAGE"
                    [value]="imageData.images.length.toString()"/>
                }
              </div>
            }
            <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentFixedTagContainer">
              @if (poi.annotationToPointOfInterest.length > 0) {
                <p-tag
                  [icon]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.ANNOTATIONS"
                  [value]="poi.annotationToPointOfInterest.length.toString()"/>
              }
            </div>
            <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentFixedTagContainer">&nbsp;</div>
            <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentFixedTagContainer">&nbsp;</div>
            <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentOptionContainer">
              @if (!selectionData.hasBulkEditPoi) {
                <medsurf-design-input-menu
                  [formField]="false"
                  [name]="'image_poi_menu_' + poi.id"
                  [tooltipLabel]="'global.image_poi_menu' | translate"
                  [class.tree_hidden_element]="!selectionData.selected"
                  [buttonInputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_SMALL_OUTLINED"
                  [iconOpen]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.OPTIONS"
                  [iconClose]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.OPTIONS"
                  [loadContext]="{type: 'imagePoi', poi, image, images: imageData.images}"
                  [loadMenuItems]="getImagePoiMenuItems"
                (click)="templateSlideTree.handleEvent()"></medsurf-design-input-menu>
              }
            </div>
          </div>
        }
      }
    </div>
  </ng-template>

  <!-- Question Template -->
  <ng-template #override_question_template
    let-templateSlideTree="templateSlideTree"
    let-question="question"
    let-depth="depth">
    <div [class]="FlatModels.TreeDesignModels.TreeDragNode">
      @if ({
        selected: slideAuthorFacade.isQuestionSelected$(question.id) | async,
        hasBulkEditQuestion: slideAuthorFacade.hasBulkEditQuestion$(question.id) | async
      }; as selectionData) {
        <div [id]="'se-' + question.id"
          [class]="FlatModels.TreeDesignModels.TreeDragNodeContent"
          [class.selected]="selectionData.selected"
          (click)="setQuestionId($event, question.id)">
          <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentHandleContainer">
            <button medsurf-design-input-button [id]="'question_handle_' + question.id"
              [title]="'global.question_handle' | translate"
              [class]="FlatModels.TreeDesignModels.TreeDragNodeHandleElement"
              [class.tree_hidden_element]="!selectionData.selected"
              [class.opacity-0]="selectionData.hasBulkEditQuestion"
              [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.HANDLE_TEXT"
            [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.MOVE"></button>
          </div>
          <!--
          <div class="flex w-3rem">
            <medsurf-design-input-checkbox [formField]="false"
              *ngIf="{ hasBulkEditQuestion: nodeSharedFacade.hasBulkEditQuestion$(question.id) | async } as pageData"
              [class]="'table-header-switch'"
              [model]="pageData.hasBulkEditQuestion"
              [name]="'question_select_all_' + question.id"
            (valueChange)="onToggleBulkQuestion($event, question.id)"></medsurf-design-input-checkbox>
          </div>
          -->
          <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentDropDownContainer(depth)">
            <i [class]="FlatModels.QuestionEntityModels.QuestionTypeIcon[question.type]"></i>
          </div>
          <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentTitleContainer">
            <span [class]="FlatModels.TreeDesignModels.TreeDragNodeContentText"
              [title]="question.content | stripTags"
              [innerHTML]="question.content | stripTags">
            </span>
          </div>
          <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentOptionContainer">
            @if (!selectionData.hasBulkEditQuestion) {
              <medsurf-design-input-menu
                [formField]="false"
                [name]="'question_menu_' + question.id"
                [tooltipLabel]="'global.question_menu' | translate"
                [class.tree_hidden_element]="!selectionData.selected"
                [buttonInputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_SMALL_OUTLINED"
                [iconOpen]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.OPTIONS"
                [iconClose]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.OPTIONS"
                [loadContext]="{type: 'question', question}"
                [loadMenuItems]="getQuestionMenuItems"
              (click)="templateSlideTree.handleEvent()"></medsurf-design-input-menu>
            }
          </div>
        </div>
      }
    </div>
  </ng-template>

</medsurf-design-content-template-slide-tree>